import React from 'react';
import DataQualityRoute from '../features/data-quality/DataQualityRoute';

const DataQualityHub: React.FC<{ className?: string }> = ({ className = '' }) => {
  return <DataQualityRoute className={className} />;
};

export default DataQualityHub;
